function backButtonGetRecentHistory (storage: Storage) {
  return storage.getItem('recentHistoryV2')?.split('\\') || []
}

/**
 * Transforms an URL like http://localhost:5001/backoffice/castings/249142 into /backoffice/castings
 *
 * A "universe" is a group of pages arround the same object (typically, corresponding to an item in the main menu).
 */
export function backButtonGetUniverse (url: string) {
  return new URL(url).pathname.split('/').slice(0, 3).join('/')
}

export function backButtonStoreCurrentUrl (storage: Storage, currentLocation: string) {
  let recentHistory = backButtonGetRecentHistory(storage)

  // Reset recentHistory if currentLocation (excluding query and hash) is same than previous URL universe.
  // That would mean the users went back from a deep context to the main index.
  if (backButtonGetUniverse(currentLocation) === new URL(currentLocation).pathname) recentHistory = [currentLocation]
  else if (recentHistory[0] != currentLocation) recentHistory.unshift(currentLocation)

  storage.setItem('recentHistoryV2', recentHistory.slice(0, 30).join('\\'))
}

export function backButtonGetBackUrl (storage: Storage, universe: string, preferredBackUrl: string) {
  const urlsFromHistory = backButtonGetRecentHistory(storage).slice(1) // start from index 1 to exclude current location
  const urlsFromHistorySize = urlsFromHistory.length

  for (let i = 0; i < urlsFromHistorySize; i++) {
    const url = urlsFromHistory.shift()

    // Matched back URL: the mostrecent URL that is "equal" (with some approx.) to preferredBackUrl, or the source universe (ex. te customer those invoice ha been opened) in fallback
    if (backButtonGetUniverse(url) !== universe || new URL(url).pathname === new URL(preferredBackUrl).pathname) return url
  }

  return preferredBackUrl
}

export function backButtonNavigateBack (storage: Storage, backUrl: string, setCurrentLocation: (href: string) => void) {
  const urlsFromHistory = backButtonGetRecentHistory(storage).slice()
  const backUrlIndex = urlsFromHistory.indexOf(backUrl)

  // Forget navigations until the navigated by URL
  if (backUrlIndex > -1) storage.setItem('recentHistoryV2', urlsFromHistory.slice(backUrlIndex).join('\\'))
  else storage.removeItem('recentHistoryV2')
  setCurrentLocation(backUrl)
}